import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { DelegationofauthorityService } from '../../../../services/delegationofauthority/delegationofauthority.service';

@Component({
  selector: 'app-previewreport',
  templateUrl: './previewreport.component.html',
  styleUrls: ['./previewreport.component.css'],
  imports: [CommonModule, MatTableModule]
})
export class PreviewReportComponent implements OnInit {
  reportTitle: string = '';
  displayedColumns: string[] = [];
  dataSource: any[] = []; 
  reportWidth: string = '';
  fontSize: string = '';

  constructor(private delegationService: DelegationofauthorityService) { }

  ngOnInit(): void {
    const state = history.state.data;
    // debugger
    
    // console.log('history.state.data =', history.state.data);
    // console.log('state.data =', state.data);
    if (state) {
      this.reportTitle = state.title;
      this.displayedColumns = state.columns;
      this.reportWidth = state.width;
      this.fontSize = state.fontSize;
    }

    // Fetch the data for the table here
    // this.dataSource = ...
  }

  downloadExcel(): void {
    this.delegationService.perviewReportExcel(this.dataSource).subscribe((response: any) => {  // Explicitly specify the type of 'response'
      console.log('Data sent successfully', response);
    }, (error: any) => {  
      console.error('Error sending data', error);
    });
  }


}